var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-dash-view"},[_c('page-header',{attrs:{"title":"Expert Dashboard"}},[_c('v-tabs',{attrs:{"background-color":"transparent","hide-slider":""}},[_c('v-tab',{attrs:{"to":{
          name: 'expert-dashboard-properties',
        },"exact-path":""}},[_vm._v(" Properties ")]),_c('v-tab',{attrs:{"to":{
          name: 'expert-dashboard-surveys',
        }}},[_vm._v(" Surveys ")]),_c('v-tab',{attrs:{"to":{
          name: 'expert-dashboard-bboxes',
        }}},[_vm._v(" Stickybeak ")])],1)],1),_c('v-container',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }